import React, { useState, useRef, useEffect } from 'react';
import Sticky from 'react-sticky-el';
import Header from './common/Header'
import Footer from './common/Footer'
import styles from './pricing.module.css'
import logo from './img/quanto_light.png'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Import icons
import './style/WhyQuanto.css';
export default function Pricing() {
    const [isAnnual, setIsAnnual] = useState(false);

    const features = {
        useCase: ["For Business that are getting started", "For Business that are expanding", "For One time Payment Method and Large Format Stores"],
        basics: [
            { name: 'Basics', values: ['', '', ''], header: true },
            { name: 'Installation', values: ['Cloud', 'Cloud', 'Offline Server or Cloud'] },
            { name: 'Type of License', values: ['Single Company & Single Location', 'Multi Company & Multi Location', 'Multi Company & Multi Location', ''] },
            { name: 'AMC and Cloud Charges', values: ['Included in the Subscription Charges', 'Included in the Subscription Charges', 'AMC @ 20 % , Cloud Charges based on Storage', ''] },
            { name: 'Limit of Usage', values: ['1 User Compulsary for every 50 L of Stock Value. For eg - If Stock Value is 2 Cr, Minimum 4 Users to buy', '1 User Compulsary for every 50 L of Stock Value', 'For eg - If Stock Value is 2 Cr, Minimum 4 Users to buy', 'Unlimited Users'] },
            { name: 'Onboarding Online Training and Implementation', values: ['Rs 7,500 One Time (Upto 10 Hours of Training & Implementation) ', 'Rs 10,000 One Time (Upto 20 Hours of Training & Implementation)', 'Free Days based on the Quotation'] },
            { name: 'New Branch Implementation', values: ['Rs 5,000 One Time', 'Rs 10,000 One Time', 'Branch License Cost Applicable', 'Customised Quote'] },
            { name: 'POS Bill Design', values: ['Included Upto 3 times', 'Included Upto 5 times', 'Included Upto 10 times', 'Included Upto 10 times'] },
            { name: 'Barcode Sticker Design', values: ['Included Upto 3 times', 'Included Upto 5 times', '✓', '✓'] },
            { name: 'SMS Integration', values: ['Rs 2000', 'FREE*', 'FREE*'] },
            { name: 'Whats app Integration', values: ['Rs 3500', 'Rs 3500', 'Rs 5000'] },
        ],
        inventory: [
            { name: 'Warehouse Management', values: ['', '', ''], header: true },
            { name: 'Warehouse Dashboard', values: ['✓', '✓', '✓'] },
            { name: 'Courier Entry', values: ['✗', '✗', '✓'] },
            { name: 'Transport Issue & Receipt Entry', values: ['✗', '✗', '✓'] },
            { name: 'LR Entry to Barcode Generation', values: ['✓', '✓', '✓',] },
            { name: 'GRN to Purchase Order Auto Flow', values: ['✗', '✗', '✓'] },
            { name: 'Barcode Image Upload Option', values: ['✗', 'Rs 500/month for 1GB Storage', '✓'] },
            { name: 'Stock Transfers', values: ['✗', '✓', '✓',] },
            { name: 'Purchase Return', values: ['✓', '✓', '✓'] },
            { name: 'Physical Stock Audit', values: ['✓', '✓', '✓'] },
            { name: 'Stock Item Locator', values: ['✓', '✓', '✓'] },
            { name: 'Job Work Module', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Warehouse Daily Reports', values: ['✓', '✓', '✓'] },
        ],
        crm: [
            { name: 'CRM Management', values: ['', '', ''], header: true },
            { name: 'Customer data Management', values: ['✓', '✓', '✓'] },
            { name: 'Loyalty Points Management', values: ['✓', '✓', '✓'] },
            { name: 'Coporate Orders Tracking', values: ['✗', '✓', '✓'] },
            { name: 'Customer History', values: ['✓', '✓', '✓',] },
            { name: 'Gift Voucher', values: ['✓', '✓', '✓',] },
            { name: 'Gift Coupon', values: ['✓', '✓', '✓',] },
            { name: 'Send SMS from Software', values: ['✗', '✓', '✓',] },
            { name: 'Customer Diversion', values: ['✗', '✗', '✓'] },
            { name: 'Feedback Management', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Lead Management', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Alteration', values: ['✗', '✗', '✓'] },
        ],
        sales: [
            { name: 'Sales Management', values: ['', '', ''], header: true },
            { name: 'POS Sales with Settlement', values: ['✓', '✓', '✓'] },
            { name: 'POS Sales Return/Exchange', values: ['✓', '✓', '✓'] },
            { name: 'POS Sales Credit Note with Expiry', values: ['✗', '✗', '✓'] },
            { name: 'B2b Sales Invoice', values: ['✗', '✓', '✓',] },
            { name: 'Delivery Counter', values: ['✗', '✓', '✓',] },
            { name: 'Gift Delivery', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Cash Opening & Closing', values: ['✓', '✓', '✓'] },
            { name: 'Sales on Approval', values: ['✗', '✗', '✓'] },
            { name: 'B2b Sales Dashboard', values: ['✗', '✓', '✓',] },
            { name: 'Sales Daily Reports', values: ['✓', '✓', '✓'] },
        ],
        finance: [
            { name: 'Finance Management', values: ['', '', ''], header: true },
            { name: 'Tally Integration', values: ['Rs 10,000 One Time', 'Rs 10,000 One Time', '✓'] },
            { name: 'Petty Cash', values: ['✗', '✓', '✓',] },
            { name: 'Supplier Payment', values: ['✗', '✓', '✓',] },
            { name: 'Transport Payment', values: ['✗', '✓', '✓',] },
            { name: 'GST Pack ', values: ['✗', '✗', 'Add On Feature'] },
        ],
        advanced_finance: [
            {
                name: 'Advanced Finance Management', values: ['✗', '✗', 'Add On Feature'],
                points: [
                    "Ledger Creation",
                    "Voucher Entry",
                    "Cheque Printing",
                    "Day Book",
                    "Payables/Receivables",
                    "Trail Balance",
                    "Profit and Loss Account",
                    "Balance Sheet"
                ],
            },
        ],
        store: [
            { name: 'Store Management', values: ['', '', ''], header: true },
            { name: 'Inter-Branch Stock Transfers', values: ['✗', '✓', '✓',] },
            { name: 'Split Barcode', values: ['✓', '✓', '✓',] },
            { name: 'Price Changer', values: ['✓', '✓', '✓',] },
            { name: 'Gift Pack Creation', values: ['✓', '✓', '✓',] },
            { name: 'Last Bit Conversion', values: ['✓', '✓', '✓',] },
            { name: 'Sales Promotion Scheme', values: ['✗', '✓', '✓',] },
            { name: 'Stock Marker', values: ['✗', '✗', '✓',] },
            { name: 'Tailoring Module', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Puchase Indent', values: ['✗', '✗', '✓',] },
            { name: 'Purchase Order', values: ['✗', '✗', '✓',] },
        ],
        analyticals: [
            { name: 'Analyticals', values: ['', '', ''], header: true },
            { name: 'Dynamic Dashboard', values: ['✓', '✓', '✓'] },
            { name: 'Customised Dashboard', values: ['✗', '✗', '✓',] },
            { name: 'Stock Analyser', values: ['✓', '✓', '✓'] },
            { name: 'Sales Analyser', values: ['✓', '✓', '✓'] },
            { name: 'Purchase Analyser', values: ['✗', '✓', '✓'] },
            { name: 'CRM Analyser', values: ['✗', '✓', '✓'] },
            { name: 'Sales Comparer', values: ['✗', '✓', '✓'] },
            { name: 'Sales Vs Purchase', values: ['✗', '✗', '✓'] },
            { name: 'Sales Vs Stock', values: ['✗', '✗', '✓'] },
            { name: 'Stock Marker Analyser', values: ['✗', '✗', '✓'] },
            { name: 'Re order Level', values: ['✗', '✗', '✓'] },
            { name: 'Report Builder', values: ['✗', '✓', '✓'] },
            { name: 'Purchase Planner', values: ['✗', '✗', '✓'] },
            { name: 'Revenue Generation', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Image Gallery', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'AI Powered GST Range Tax Config', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'Basic Incentive Configuration', values: ['✗', '✓', '✓'] },
            { name: 'Advanced Incentive Configuration', values: ['✗', '✗', '✓'] },
            { name: 'Sales Man Target Management', values: ['✗', '✗', 'Add On Feature'] },
            { name: 'UAN Barcode Configuration', values: ['✗', 'Rs 500/month', 'Add On Feature'] },
            { name: 'Third Party Integration', values: ['Working Charges', 'Working Charges', 'Working Charges'] },
            { name: 'Android Mobile App without Billing', values: ['✓', '✓', '✓'] },
            { name: 'Android Mobile App with Billing', values: ['Rs 500/month', 'Rs 500/month', 'Add On Feature'] },
        ]
    }

    const plans = [
        { name: 'Quanto SaaS Lite', price: 1750 },
        { name: 'Quanto SaaS Premium', price: 2750, popular: true },
        { name: 'Quanto Enterprise Version', price: "Customised Quote", customized: true },
    ]

    const [expandedFeatures, setExpandedFeatures] = useState({});

    const toggleFeature = (featureIndex) => {
        setExpandedFeatures((prevState) => ({
            ...prevState,
            [featureIndex]: !prevState[featureIndex],
        }));
    };

    // Before the return statement, add this ref
    const notesRef = useRef(null);

    const [disableSticky, setDisableSticky] = useState(false);

    // when scrolled to notes ref then setDisatbleSticky to true
    const handleScroll = () => {
        if (window.scrollY >= (notesRef.current.offsetTop - 250)) {
            setDisableSticky(true);
        } else {
            setDisableSticky(false);
        }
    };

    // Add event listener using useEffect
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        // Remove event listener on cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    
    const formatNumberIndian = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    const isMobile = window.innerWidth < 768;

    return (
        <>
            <Header />
            {/* <section className="pricing-title-section">
                <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} />Pricing</h2>
            </section> */}
            <section className="about-title-section pricing-section-header">
                <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} />Pricing</h2>
            </section>
            <div className="modern-pricing-header">
                <h2>“Whether small format or a large-format store, we are here to serve businesses of all sizes.”</h2>
                <p>Flexible and affordable pricing. Made for every growing business.</p>
            </div>
            <div className={styles.pricingContainer}>
                <div className={styles.billing_toggle_container}>
                    <span className={`billing-text ${!isAnnual ? 'active' : ''}`}>
                        Monthly billing
                    </span>

                    <label className={styles.toggle}>
                        <input
                            type="checkbox"
                            checked={isAnnual}
                            onChange={() => setIsAnnual(!isAnnual)}
                        />
                        <span className={styles.slider}></span>
                    </label>

                    <div className={styles.annual_section}>
                        <span className={`${styles.billing_text} ${isAnnual ? styles.active : ''}`}
                            style={{
                                marginTop: 20
                            }}
                        >
                            Annual billing
                        </span>
                        <div className={styles.annual_note}>
                            <svg
                                viewBox="0 0 24 24"
                                className={styles.arrow_icon}
                                style={{ transform: 'rotate(-45deg)' }}
                            >
                                <path d="M7 14l5-5 5 5" />
                            </svg>
                            <span>Pay for 11 months and use for an year!</span>
                        </div>
                    </div>
                </div>

                {/* <div className={styles.pricingHeader}>
                    <div className={styles.toggleContainer}>
                        <span className={!isYearly ? styles.active : ''}>Monthly</span>
                        <label className={styles.toggle}>
                            <input
                                type="checkbox"
                                checked={isYearly}
                                onChange={() => setIsYearly(!isYearly)}
                            />
                            <span className={styles.slider}></span>
                        </label>
                        <span className={isYearly ? styles.active : ''}>Yearly</span>
                    </div>
                </div> */}

                <div className={styles.pricingContent}>
                    {/* <div className={styles.featuresColumn}>
                        <h2>All Features</h2>
                        <div className={styles.featureSection}>
                            <h3>BASICS</h3>
                            {features.basics.map((feature, index) => (
                                <div key={index} className={styles.featureRow}>
                                    <span>{feature.name}</span>
                                </div>
                            ))}
                        </div>
                        <div className={styles.featureSection}>
                            <h3>INVENTORY MANAGEMENT</h3>
                            {features.inventory.map((feature, index) => (
                                <div key={index} className={styles.featureRow}>
                                    <span>{feature.name}</span>
                                </div>
                            ))}
                        </div>
                    </div> */}
                    <div className={styles.planGroupContainer} style={{ background: 'white' }}>
                        <h2 className={styles.planGroupTitle} style={{ color: 'white' }}>Quanto SaaS Module</h2>
                        <p className={styles.planGroupDescription} style={{ color: 'white' }}>"Affordable Plans, Scalable Growth."</p>
                        <div className={styles.planGroup2}>

                            <div key={0} className={`${styles.planColumn} ${plans[0].popular ? styles.popular : ''}`}
                                style={{
                                    border: '✗ne',
                                }}
                            >
                                {plans[0].popular && <div className={styles.popularTag}>Most Popular</div>}
                                <Sticky topOffset={81} disabled={isMobile || disableSticky}>
                                    <div className={styles.planHeader} style={{ background: 'white' }}>
                                        <h3 style={{ color: "white" }}>{plans[0].name}</h3>
                                        <div className={styles.price}>
                                            {!plans[0].customized && <span className={styles.currency} style={{ color: "white" }}>₹</span>}
                                            {!plans[0].customized ? <span className={styles.amount} >All Features</span>
                                                : <span className={styles.customized} style={{ color: "white" }}>Customised Quote</span>
                                            }

                                        </div>
                                        <div className={styles.billingPeriod} style={{ color: "white" }}>/month billed annually</div>
                                        <div className={styles.useCase} style={{ color: "white" }}>/month billed annually</div>
                                        {/* <button className={styles.accessBu</div>tton} style={{ color: "white", backgroundColor: 'white' }}>ACCESS ZAKYA</button> */}
                                    </div>
                                </Sticky>
                                <div className={styles.planFeatures}>
                                    {features.basics.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.basics[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                    {features.inventory.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.inventory[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                    {features.crm.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.crm[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                    {features.sales.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.sales[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                    {features.finance.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.finance[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                    {features.advanced_finance.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={styles.featureRowPoints}>
                                            <span onClick={() => toggleFeature(featureIndex)}>
                                                {feature.name}
                                                {expandedFeatures[featureIndex] ?
                                                    <FaChevronUp /> :
                                                    <FaChevronDown />
                                                }
                                            </span>
                                            {expandedFeatures[featureIndex] && (
                                                <ul style={{ maxHeight: expandedFeatures[featureIndex] ? '500px' : '0' }}>
                                                    {feature.points.map((point, index) => (
                                                        <li key={index}>{point}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                                    {features.store.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.store[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                    {features.analyticals.map((feature, featureIndex) => (
                                        <div key={featureIndex} className={`${styles.featureRow} ${features.analyticals[featureIndex].header ? styles.planGroupHeader : ''}`}>
                                            <span>{feature.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.planGroupContainer}>
                        <h2 className={styles.planGroupTitle}>Quanto SaaS Module</h2>
                        <p className={styles.planGroupDescription}>"Affordable Plans, Scalable Growth."</p>
                        <div className={styles.planGroup}>

                            {[0, 1].map((planIndex) => {
                                const plan = plans[planIndex];
                                return (
                                    <div key={planIndex} className={`${styles.planColumn} `}>
                                        {plan.popular && <div className={styles.popularTag}>Most Popular</div>}
                                        <Sticky topOffset={81} disabled={isMobile || disableSticky}>
                                            <div className={styles.planHeader} style={{ background: 'white' }}>
                                                <h3>{plan.name}</h3>
                                                <div className={styles.price}>
                                                    {!plan.customized && <span className={styles.currency}>₹</span>}
                                                    {!plan.customized ?
                                                        <span className={styles.amount}>
                                                            {formatNumberIndian(isAnnual ? plan.price * 11 : plan.price)}
                                                        </span>
                                                        : <span className={styles.customized}>Customised Quote</span>
                                                    }
                                                </div>
                                                <div className={styles.billingPeriod}>
                                                    {isAnnual ? '/year/user' : '/month/user'}
                                                </div>
                                                <div className={styles.useCase}>{features.useCase[planIndex]}</div>
                                                {/* <button className={styles.accessButton}>ACCESS ZAKYA</button> */}

                                            </div>
                                        </Sticky>
                                        <div className={styles.planFeatures}>
                                            {features.basics.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.inventory.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.crm.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.sales.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.finance.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.advanced_finance.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRowPoints}>
                                                    <span onClick={() => toggleFeature(featureIndex)}>
                                                        {feature.values[planIndex]}
                                                        {/* {expandedFeatures[featureIndex] ?
                                                            <FaChevronUp /> :
                                                            <FaChevronDown />
                                                        } */}
                                                    </span>
                                                    {expandedFeatures[featureIndex] && (
                                                        <ul style={{
                                                            maxHeight: expandedFeatures[featureIndex] ? '500px' : '0',
                                                            transition: 'max-height 0.3s ease-in-out',
                                                            overflow: 'hidden'
                                                        }}>
                                                            {feature.points.map((point, index) => (
                                                                <li key={index} style={{
                                                                    color: 'white',
                                                                    listStyle: 'none',
                                                                }}>{point}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            ))}
                                            {features.store.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.analyticals.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className={styles.planGroupContainer}>
                        <h2 className={styles.planGroupTitle}>Quanto ERP Module</h2>
                        <p className={styles.planGroupDescription}>"Balanced Costs, Big Possibilities."</p>
                        <div className={styles.planGroup2}>

                            {[2].map((planIndex) => {
                                const plan = plans[planIndex];
                                return (
                                    <div key={planIndex} className={`${styles.planColumn} ${plan.popular ? styles.popular : ''}`}>
                                        {plan.popular && <div className={styles.popularTag}>Most Popular</div>}
                                        <Sticky topOffset={81} disabled={isMobile || disableSticky}>
                                            <div className={styles.planHeader} style={{ background: plan.popular ? '#000' : 'white' }}>
                                                <h3>{plan.name}</h3>
                                                <div className={styles.price}>
                                                    {!plan.customized && <span className={styles.currency}>₹</span>}
                                                    {!plan.customized ?
                                                        <span className={styles.amount}>
                                                            {formatNumberIndian(isAnnual ? plan.price * 11 : plan.price)}
                                                        </span>
                                                        : <span className={styles.customized}>Customised Quote</span>
                                                    }
                                                </div>
                                                {!isMobile ? <div className={styles.billingPeriod} style={{ color: "white" }}>
                                                    {'/year/user'}
                                                </div> :
                                                    <div style={{ height: 10 }}></div>
                                                }
                                                <div className={styles.useCase}>{features.useCase[planIndex]}</div>
                                                {/* <button className={styles.accessButton}>ACCESS ZAKYA</button> */}

                                            </div>
                                        </Sticky>
                                        <div className={styles.planFeatures}>
                                            {features.basics.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.inventory.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.crm.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.sales.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.finance.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.advanced_finance.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRowPoints}>
                                                    <span onClick={() => toggleFeature(featureIndex)}>
                                                        {feature.values[planIndex]}
                                                        {/* {expandedFeatures[featureIndex] ?
                                                            <FaChevronUp /> :
                                                            <FaChevronDown />
                                                        } */}
                                                    </span>
                                                    {expandedFeatures[featureIndex] && (
                                                        <ul style={{
                                                            maxHeight: expandedFeatures[featureIndex] ? '500px' : '0',
                                                            transition: 'max-height 0.3s ease-in-out',
                                                            overflow: 'hidden'
                                                        }}>
                                                            {feature.points.map((point, index) => (
                                                                <li key={index} style={{
                                                                    color: 'white',
                                                                    listStyle: 'none',
                                                                }}>{point}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            ))}
                                            {features.store.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                            {features.analyticals.map((feature, featureIndex) => (
                                                <div key={featureIndex} className={styles.featureRow}>
                                                    <span>{feature.values[planIndex]}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                        </div >
                    </div >
                </div >
                <div className={styles.notesSection} ref={notesRef}>
                    <h2>Notes</h2>
                    <ul className={styles.notesList}>
                        <li>All Prices mentioned above are Exclusive of GST@18%</li>
                        <li>Onboarding Training & Implementation Additional Hour Charges Rs 500</li>
                        <li>Additional Bill Design or Sticker Design Rs 500 Each</li>
                        <li>Additional Online Software Training charges Rs 5000 Per Day</li>
                        <li>AMC shall cover only Support activites and New Updates by Quanto</li>
                        <li>Prices are subject to change without any prior notice</li>
                    </ul>
                </div>
            </div >
            <Footer />
        </>
    );
}
